import client from './client.ts';

export type BulkAvailabilityPayload = {
  start: string; // YYYY-MM-DD
  end: string;   // YYYY-MM-DD
  allotment?: number;
  closed?: boolean;
  priceOverride?: number;
};

const base = '/api/v1/admin/hotels';

export const applyHotelAvailability = async (hotelId: number, payload: BulkAvailabilityPayload): Promise<void> => {
  await client.post(`${base}/${hotelId}/availability`, payload);
};

export const applyRoomTypeAvailability = async (roomTypeId: number, payload: BulkAvailabilityPayload): Promise<void> => {
  await client.post(`${base}/room-types/${roomTypeId}/availability`, payload);
};


